import { render, staticRenderFns } from "./NotificationTextarea.vue?vue&type=template&id=a58c5c30"
import script from "./NotificationTextarea.vue?vue&type=script&lang=js"
export * from "./NotificationTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports